export const releaseStage = process.env.NEXT_PUBLIC_ENV as
  | 'production'
  | 'preview'
  | 'development';

export const isProdRelease = releaseStage === 'production';
